/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-empty-function */
import { QueryParams } from '@buy-viasat/types/build/bv';
import { RESET_STATE_ACTION } from '../types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../utils';
import { NavState, Routes, RouteContext } from './types';
import {
  routeSequence,
  buildRoutes,
  buildRouteStates,
  furthestStepInFlow,
  getStepNumber,
  getTotalSteps,
} from './utils';

export const initialNavState: NavState = {
  currentAppRoute: Routes.SERVICEABILITY,
  routeStates: null,
  maxRoute: Routes.SERVICEABILITY,
  currentStep: 0,
  totalSteps: 0,
  routeSequence,
  routeContext: null,
};

const navigatorSlice = createSlice({
  name: 'navigator',
  initialState: initialNavState,
  reducers: {
    routeUserTo({}, payload: PayloadAction<Routes>): void {},
    onRouteButtonPress({}, payload: PayloadAction<Routes>): void {},
    computeRoutes(state: NavState, action: PayloadAction<RouteContext>) {
      const routeSequence = buildRoutes(action.payload);
      const routeStates = buildRouteStates(routeSequence);
      const totalSteps = getTotalSteps(routeSequence);
      const currentStepNumber = getStepNumber(routeSequence, state.currentAppRoute);

      state.routeContext = action.payload;
      state.routeSequence = routeSequence;
      state.routeStates = routeStates;
      state.totalSteps = totalSteps;
      state.currentStep = currentStepNumber;
      state.maxRoute = furthestStepInFlow(routeSequence, state.maxRoute);
    },
    resetRouteStates(state: NavState) {
      state.routeStates = initialNavState.routeStates;
    },
    setCurrentAppRoute(state: NavState, action: PayloadAction<Routes>) {
      if (Object.values(Routes).includes(action.payload)) {
        state.currentAppRoute = action.payload;
      } else {
        state.currentAppRoute = Routes.SERVICEABILITY;
      }

      state.currentStep = getStepNumber(state.routeSequence, state.currentAppRoute);
    },
    // MISC
    onSubmitOrder(): void {},
    onEditScheduleInstallationPress(): void {},
    onEditPersonalInformationPress(): void {},
    onEditPaymentInformationPress(): void {},
    scrubShippingAddress(): void {},
    setupAppRoutes(): void {},
    next(): void {},
    previous(): void {},
    reset(): void {},
    onSessionReset(state: NavState, payload: PayloadAction<{ route: Routes; inputParams: QueryParams }>): void {},
    setMaxRoute(state: NavState, action: PayloadAction<Routes>): void {
      const { routeStates, maxRoute } = state;
      state.maxRoute =
       routeStates === null || routeStates[action.payload].order > routeStates[maxRoute].order
          ? action.payload
          : state.maxRoute;
    },
    invalidateProgressFrom(state: NavState, action: PayloadAction<Routes>): void {
      const { maxRoute, routeStates } = state;
      if (routeStates === null) {
        return;
      }
      state.maxRoute =
        routeStates[action.payload].order < routeStates[maxRoute].order
          ? action.payload
          : state.maxRoute;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): NavState => initialNavState);
  },
});

const resetState = createAction(RESET_STATE_ACTION.type);

export const { actions: navActions, reducer: navReducer, name: navKey } = navigatorSlice;
